"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectAddress = exports.resetFindAddressError = exports.resetAddressSearch = exports.enterManualAddress = void 0;
var _addressActionConstants = require("./addressActionConstants");
var selectAddress = exports.selectAddress = function selectAddress(_ref) {
  var addressId = _ref.addressId,
    address = _ref.address,
    _ref$replaceGbTerrito = _ref.replaceGbTerritoryCountryCodes,
    replaceGbTerritoryCountryCodes = _ref$replaceGbTerrito === void 0 ? true : _ref$replaceGbTerrito;
  return {
    type: "".concat(addressId, "_").concat(_addressActionConstants.SELECT_ADDRESS),
    address: address,
    replaceGbTerritoryCountryCodes: replaceGbTerritoryCountryCodes
  };
};
var enterManualAddress = exports.enterManualAddress = function enterManualAddress(_ref2) {
  var addressId = _ref2.addressId,
    international = _ref2.international,
    countryCode = _ref2.countryCode;
  return {
    type: "".concat(addressId, "_").concat(_addressActionConstants.ENTER_MANUAL_ADDRESS),
    international: international,
    countryCode: countryCode
  };
};
var resetAddressSearch = exports.resetAddressSearch = function resetAddressSearch(_ref3) {
  var addressId = _ref3.addressId,
    countryCode = _ref3.countryCode;
  return {
    type: "".concat(addressId, "_").concat(_addressActionConstants.RESET_ADDRESS_SEARCH),
    countryCode: countryCode
  };
};
var resetFindAddressError = exports.resetFindAddressError = function resetFindAddressError(_ref4) {
  var addressId = _ref4.addressId;
  return {
    type: "".concat(addressId, "_").concat(_addressActionConstants.RESET_FIND_ADDRESS_ERROR)
  };
};